export enum ActivitySubscriptionType {
  Web = 'web',
  Mobile = 'mobile',
  Email = 'email',
  Slack = 'slack',
}
